var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/user-menu/RenderUserMenu.tsx",
  _this = this;
import React, { useContext } from 'react';
import { defineMessages, t } from '@sm/intl';
import { Box } from '@wds/box';
import { IconCaretDown } from '@wds/icons';
import { Menu } from '@wds/menu';
import { List } from '@wds/list';
import { Accordion } from '@wds/accordion';
import { Responsive } from '@wds/responsive';
import { generateMetricsAttribute, MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { SubMenuItem } from '../mobile-nav/SubMenuItem';
import { NavButton } from '../nav-button';
import HeaderContext from '../../HeaderContext';
var COPY = defineMessages({
  OPEN_USER_MENU: {
    id: 'RenderUserMenu.Open',
    defaultMessage: 'Open user menu',
    description: '[Type: Label][Vis.: high] - Button that opens and closes the user menu.'
  },
  EXPAND_ARROW_ICON: {
    id: 'RenderUserMenu.Dropdown',
    defaultMessage: 'Dropdown arrow icon',
    description: '[Type: Label][Vis.: high] - Expand arrow icon.'
  }
});
var UserDropDownTrigger = function UserDropDownTrigger(username) {
  return /*#__PURE__*/React.createElement(NavButton, {
    label: t(COPY.OPEN_USER_MENU),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }, username, /*#__PURE__*/React.createElement(Box, {
    ml: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconCaretDown, {
    title: t(COPY.EXPAND_ARROW_ICON),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 9
    }
  })));
};
var RenderUserMenu = function RenderUserMenu(_ref) {
  var username = _ref.username,
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems;
  var _useContext = useContext(HeaderContext),
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  var TrackMenuEvents = function TrackMenuEvents(opened) {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        url: pageURL,
        pageName: pageName,
        amplitudeEvent: 'header clicked menu',
        menuName: 'username',
        opened: opened
      }
    });
  };
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "md",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 5
    }
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement(Menu, {
      placement: "bottom-right",
      menuTrigger: UserDropDownTrigger(username),
      noRules: true,
      elevation: 10000,
      onChange: function onChange(showMenu) {
        return TrackMenuEvents(showMenu);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 11
      }
    }, menuItems.map(function (item) {
      return /*#__PURE__*/React.createElement(Menu.Item, {
        key: item.name,
        navigationTarget: item.path,
        isNavigable: true,
        "data-sm-metrics": generateMetricsAttribute({
          data: {
            url: pageURL,
            pageName: pageName,
            amplitudeEvent: 'header clicked navigation',
            navItem: item.navItem
          }
        }),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81,
          columnNumber: 15
        }
      }, item.name);
    })) : /*#__PURE__*/React.createElement(Accordion, {
      interactive: true,
      onChange: function onChange(e) {
        return TrackMenuEvents(!e.length);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Accordion.Item, {
      title: username,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 100,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(List, {
      noRules: true,
      interactive: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 15
      }
    }, menuItems.filter(function (item) {
      return item.path.indexOf('sign-out') === -1;
    }).map(function (item) {
      return /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({
        key: item.name
      }, item, {
        "data-sm-metrics": generateMetricsAttribute({
          data: {
            url: pageURL,
            pageName: pageName,
            amplitudeEvent: 'header clicked navigation',
            navItem: item.navItem
          }
        }),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 105,
          columnNumber: 21
        }
      }));
    }))));
  });
};
export default RenderUserMenu;
//# sourceMappingURL=RenderUserMenu.js.map